import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { IUserRole } from '../../model/interfaces/user-role';
import { ClaimsService, ClaimValues } from '@mt-ng2/auth-module';
import { UserRoleService } from '../user-role.service';
import { ClaimTypes } from '../../model/ClaimTypes';
import { SearchParams } from '@mt-ng2/common-classes';
import { entityListModuleConfig } from '../../common/shared.module';
import { IEntitySearchParams } from '@mt-ng2/common-classes';
import { debounceTime } from 'rxjs/operators';
import { UserRoles } from '../../model/UserRoles';

@Component({
    selector: 'app-user-roles',
    templateUrl: './user-roles.component.html',
    standalone: false
})
export class UserRolesComponent implements OnInit {
    searchControl = new UntypedFormControl();
    userRoles: IUserRole[];
    currentPage = 1;
    total: number;
    canAddRole = false;
    itemsPerPage = entityListModuleConfig.itemsPerPage;

    constructor(private userRoleService: UserRoleService, private claimService: ClaimsService) {}

    ngOnInit(): void {
        this.searchControl.valueChanges.pipe(debounceTime(300)).subscribe(() => this.getUserRoles());

        this.canAddRole = this.claimService.hasClaim(ClaimTypes.UserRoles, [ClaimValues.FullAccess]);
        this.getUserRoles();
    }

    getUserRoles(): void {
        const search = this.searchControl.value;

        const searchEntity: IEntitySearchParams = {
            query: search && search.length > 0 ? search : '',
            skip: (this.currentPage - 1) * entityListModuleConfig.itemsPerPage,
            take: entityListModuleConfig.itemsPerPage,
        };
        const searchparams = new SearchParams(searchEntity);

        this.userRoleService.get(searchparams).subscribe((answer) => {
            this.userRoles = answer.body
                .filter((role) => ![UserRoles.DriverUser, UserRoles.DAEUser, UserRoles.HoltClerk]
                .includes(role.Id));

            this.total = +answer.headers.get('X-List-Count');
        });
    }

    clearSearch(): void {
        this.searchControl.setValue('');
    }

    noRoles(): boolean {
        return !this.userRoles || this.userRoles.length === 0;
    }

    pagingNeeded(): boolean {
        return this.total > this.itemsPerPage;
    }
}
